import { render, staticRenderFns } from "./TopNavBar.vue?vue&type=template&id=52ab2437&"
import script from "./TopNavBar.vue?vue&type=script&lang=js&"
export * from "./TopNavBar.vue?vue&type=script&lang=js&"
import style0 from "./TopNavBar.vue?vue&type=style&index=0&id=52ab2437&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports